export default [
  { title: "Menu Design and Print" },
  { title: "Wall Mount and Rigid Posters" }
];
